import { render, staticRenderFns } from "./WidgetTypeSelector.vue?vue&type=template&id=1d0e1855"
import script from "./WidgetTypeSelector.vue?vue&type=script&lang=js"
export * from "./WidgetTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./WidgetTypeSelector.vue?vue&type=style&index=0&id=1d0e1855&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports